<template>
  <div :class="background && 'bg-primary-purple-50'" class="relative rounded-2xl overflow-hidden">
    <div v-if="background" class="w-full h-full absolute">
      <div
        class="h-1/3 w-1/3 top-0 right-0 absolute border bg-warning-500 blur-3xl opacity-[12%]"
      ></div>
      <div
        class="h-1/4 w-1/4 bottom-[20%] right-[20%] absolute bg-primary-purple-500 blur-2xl opacity-[10%]"
      ></div>
      <div
        class="h-1/3 w-1/3 bottom-0 left-0 absolute bg-secondary-rose-500 blur-2xl opacity-[10%]"
      ></div>
    </div>

    <div
      :class="[
        'xl:px-[50px] transform',
        background &&
          'p-5 sm:p-[30px] md:p-10 lg:p-[50px] py-12.5 md:py-[70px] xl:py-[120px]  rounded-2xl ',
      ]"
    >
      <div class="transform">
        <div
          :class="[
            description ? 'flex items-end mb-12.5 lg:mb-17.5' : '',
            exploreBtn || email
              ? 'flex md:justify-between justify-center md:gap-12 md:flex-row flex-col '
              : 'justify-center text-center',
          ]"
        >
          <div class="relative">
            <h2
              v-if="title"
              v-i18n="landingPage"
              :class="[description ? 'mb-5 xl:mb-[25px]' : 'mb-6']"
            >
              {{ title }}
            </h2>
            <p v-if="description" v-i18n="landingPage" class="text-center">
              {{ description }}
            </p>
          </div>
          <div v-if="email" class="mb-6">
            <a
              :href="`${email?.href}${email?.subject}${email?.body}`"
              class="bg-primary-purple-600 rounded-lg text-primary-purple-600 font-medium py-2 md:py-4 px-3 md:px-7 lg:text-lg leading-34 text-base tracking-normal flex items-center gap-3 z-[1]"
            >
              <h5 v-i18n="landingPage" class="whitespace-nowrap text-white">BECOME_A_PARTNER</h5>
              <span><Icon icon="arrow-right-up" /></span>
            </a>
          </div>
          <div v-if="exploreBtn">
            <router-link to="/features">
              <div
                class="w-fit md:p-2.5 p-1.5 items-center bg-primary-purple-700 text-white gap-2.5 rounded-full flex"
              >
                <h6
                  class="uppercase py-2.5 pl-5 tracking-[0.55px] text-white font-bold whitespace-nowrap"
                >
                  Explore All Features
                </h6>
                <div
                  class="md:w-11 md:h-11 w-9 h-9 bg-white rounded-full flex justify-center items-center"
                >
                  <Icon icon="arrow-right-up" color="primary-purple-700" />
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <!-- Owl Carousel -->
        <div class="owl-carousel owl-theme">
          <div v-for="(card, index) in cards" :key="index" class="item px-2 h-full">
            <div class="h-full flex flex-col">
              <Card :card="card" :beckground="cardBackground" class="flex-grow h-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'
import Card from '@src/components/misc/Card.vue'
import Icon from '@src/components/icons/icon.vue'

export default {
  name: 'Features',
  components: {
    Card,
    Icon,
  },
  props: {
    email: { type: Object, default: null },
    cardBackground: { type: Boolean, default: false },
    exploreBtn: { type: Boolean, default: false },
    background: { type: Boolean, default: false },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    cards: { type: Array, default: () => [] },
  },
  data() {
    return {
      landingPage: 'landingPage',
      isHover: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      $('.owl-carousel').owlCarousel({
        loop: false,
        rewind: true,
        margin: 20,
        nav: false,
        dots: true,
        autoplay: true,
        slideBy: 1,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
          0: { items: 1 },
          640: { items: 1 },
          768: { items: 2 },
          1024: { items: 3 },
          1536: { items: this.cards.length > 3 ? 4 : 3 },
        },
      })
    })
  },
}
</script>

<style scoped>
:deep(.owl-carousel .owl-stage) {
  display: flex !important;
}

:deep(.owl-carousel .owl-dots .owl-dot span) {
  cursor: pointer;
  background-color: transparent;
  border-radius: 9999px;
  width: 18px;
  height: 18px;
  border: 2px solid #e9d7fe;
  display: inline-block;
  margin: 0 0.25rem;
}

:deep(.owl-carousel .owl-dots .owl-dot span:hover),
:deep(.owl-carousel .owl-dots .owl-dot.active span) {
  background-color: #b692f6;
}

:deep(.owl-carousel .owl-dots) {
  text-align: center;
  margin-top: 2rem !important;
}
</style>
